import { request } from 'Lib/axios'
import { useQuery } from '@tanstack/react-query'
import { ExtractFnReturnType, QueryConfig } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { UserAccount, PendingInvitation } from 'Types/UserAccount'

export type GetUserAccountsResponse = {
  accounts: Array<UserAccount>
  pendingInvitations: Array<PendingInvitation>
}

type QueryFnType = typeof getUserAccounts

export const useGetUserAccounts = (config?: QueryConfig<QueryFnType>) => {
  const userId = useUserStore.getState().userId

  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['userAccounts', userId],
    queryFn: () => getUserAccounts(userId),
    enabled: !!userId,
    ...config,
  })

  const data =
    !query.data || query.data instanceof Error
      ? { accounts: [], pendingInvitations: [] }
      : query.data.data

  return { ...query, data }
}

const getUserAccounts = (userId: number) => {
  return request<{ data: GetUserAccountsResponse }>({
    url: `users/${userId}/accounts`,
    method: 'GET',
  })
}
